import { gql } from "@apollo/client";

export const CREATE_TEMPLATE_WITH_FILE_CONTENT = gql`
  mutation createTemplateWithFileContent($input: CreateInvoiceInterpretationTemplateWithFileContentInput!, $clientIdentifier: String) {
    invoiceInterpretation {
      createTemplateWithFileContent(input: $input, clientIdentifier: $clientIdentifier) {
        id
        success
      }
    }
  }
`;